import { get } from "./get"

export const info = {
  get,
}
